import { connect } from 'react-redux';

import {
  createKeyAction,
  clearLastErrorAction,
} from '../../../store/keyManager/keyManagerReducers';
import KeyManagerCreateContainer from './KeyManagerCreateContainer';

const mapStateToProps = state => ({
  bearerToken: state.keyManager.bearerToken,
  displayMode: state.keyManager.displayMode,
  keys: state.keyManager.keys,
  lastError: state.keyManager.lastError,
  progress: state.keyManager.progress,
});

const mapDispatchToProps = dispatch => ({
  createKey: () => dispatch(createKeyAction()),
  clearLastError: () => dispatch(clearLastErrorAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(KeyManagerCreateContainer);
